import BaseApi from '@/api/BaseApi';
import type { IWithdrawListResponse, IWithdrawRequest } from '@/models/WithdrawModel';
import type { IPaginate } from '@/models/TableSettingsModel';

export default class WithdrawApi extends BaseApi {
	async withdrawMoney (payload: IWithdrawRequest) {
		return this.post<IWithdrawRequest, any>({
			url: `/api/withdrawal`,
            data: payload,
		});
	};

	async withdrawMoneyList (page: number, perPage: number, sortBy: string | null, sortDesc: string | null, search: string | null) {
        let url = `/api/wallet?page=${page}&per_page=${perPage}`;

        if (null != sortBy) {
            url += `&sort=${sortBy}`;
        }

        if (null != sortDesc) {
            url += `&order=${sortDesc}`;
        }

        if (null != search) {
            url += `&search=${search}`;
        }

		return this.get<IPaginate<IWithdrawListResponse>>({
			url: url,
		});
	};
};
